var map = {
	"./agriculture.svg": 1266,
	"./borehole.svg": 9139,
	"./data.svg": 9608,
	"./email.svg": 1089,
	"./ivory.svg": 9862,
	"./light.svg": 7881,
	"./people-square.svg": 3922,
	"./people.svg": 7014,
	"./pumpanddrink.svg": 2422,
	"./sdg-6-glass.svg": 155,
	"./sdg-6-tap.svg": 444,
	"./sdg-6.svg": 4196,
	"./sdg-7-energy-source.svg": 5996,
	"./sdg-7-energy.svg": 6898,
	"./sdg-7.svg": 9125,
	"./solar.svg": 2566,
	"./tap.svg": 7594,
	"./team.svg": 9984,
	"./water-square.svg": 9180,
	"./water.svg": 8604,
	"./watercarry.svg": 4025,
	"./watertank.svg": 6060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1447;